export const NPS_EBOOK_URLS: Record<'es' | 'en' | 'pt', string> = {
  es: 'https://statics.myhotel.cl/documents/ES-Guias/NPS-ES.pdf',
  en: 'https://statics.myhotel.cl/documents/ES-Guias/NPS-EN.pdf', // EN vive en ES-Guias/ (EN-Guias/ no existe en el bucket)
  pt: 'https://statics.myhotel.cl/documents/PT-Guias/NPS-PT.pdf',
};

export function getNpsEbookUrl(lang: string): string {
  return NPS_EBOOK_URLS[lang] ?? NPS_EBOOK_URLS.es;
}
